import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "ref", "transform", "transformOrigin"];
import styled from 'foundations-theming/utils';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarIconButtonGroupWrapper = styled.div.withConfig({
  displayName: "ToolbarIconButtonGroup__ToolbarIconButtonGroupWrapper",
  componentId: "ggd5yd-0"
})([".hs-private.hs-private.hs-private &{position:relative;display:flex;flex-direction:row;transform:", ";transform-origin:", ";", ";}.hs-private.hs-private.hs-private & > *:not(:first-child){margin-left:-", ";}"], ({
  $transform
}) => $transform, ({
  $transformOrigin
}) => $transformOrigin, ({
  $cssStyles
}) => $cssStyles, ({
  theme
}) => theme.borderWidth['100']);

// Omit inset shorthand because we want consumers to explicitly pass through
// each inset property in case we need to adjust the position
const ToolbarIconButtonGroup = _ref => {
  let {
      children,
      ref,
      transform = 'none',
      transformOrigin = 'none'
    } = _ref,
    tokenProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(ToolbarIconButtonGroupWrapper, {
    ref: ref,
    $cssStyles: cssStyles,
    $transform: transform,
    $transformOrigin: transformOrigin,
    children: children
  });
};
export default ToolbarIconButtonGroup;